import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { nanoid } from 'nanoid';
import { forwardRef } from 'react';
import { useGetUserQuery } from 'common';
import { useToggleState } from 'hooks/useToggleState';
import { Date, IntervalsContainer, ShowMoreButton } from './components';
import { MAX_READ_ONLY_RULES_TO_SHOW } from './constants';
import { Wrapper } from './styles';
import { getRules, groupByYear } from '../../utils';
const yearContainerCss = "y3my7rr";
const YearContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(yearContainerCss, props.className)} />;
});
const yearTextCss = "ydkt96g";
const YearText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(yearTextCss, props.className)} />;
});
const ruleContainerCss = "rr0vwuq";
const RuleContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(ruleContainerCss, props.className)} />;
});
export const DateSpecificFieldsReadOnly = ({
  dates
}) => {
  const {
    data: {
      time_notation: timeNotation
    }
  } = useGetUserQuery();
  const [showMore, toggleShowMore] = useToggleState(false);
  const rulesGroupedByInterval = getRules(dates);
  const rulesToShow = showMore ? rulesGroupedByInterval : rulesGroupedByInterval.slice(0, MAX_READ_ONLY_RULES_TO_SHOW);
  const formattedActiveDates = groupByYear(rulesToShow);
  const showShowMore = rulesGroupedByInterval.length > MAX_READ_ONLY_RULES_TO_SHOW;
  if (!formattedActiveDates.length) {
    return <Wrapper data-component="rules-container">
        <BodyText size="medium">
          {I18n.t('publisher.event_type_editor.sections.available_hours.date_overrides.none')}
        </BodyText>
      </Wrapper>;
  }
  return <Wrapper data-component="rules-container">
      {formattedActiveDates.map(([year, items]) => <YearContainer key={year} data-component={`${year}-rules`}>
          <YearText>
            <BodyText color="muted" size="x-small" weight="semibold">
              {year}
            </BodyText>
          </YearText>
          {items.map(({
        dates: dateRange,
        intervals
      }) => <RuleContainer key={nanoid(5)}>
              <Date dateRange={dateRange} withoutPadding />
              <IntervalsContainer intervals={intervals} timeNotation={timeNotation} withoutPadding />
            </RuleContainer>)}
        </YearContainer>)}
      {showShowMore && <ShowMoreButton totalRules={rulesGroupedByInterval.length} isExpanded={showMore} onClick={toggleShowMore} />}
    </Wrapper>;
};

require("./date_specific_rules_read_only.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./date_specific_rules_read_only.js");